import { render, staticRenderFns } from "./SettingPlanAddQ.vue?vue&type=template&id=33a0fa5e&scoped=true&"
import script from "./SettingPlanAddQ.vue?vue&type=script&lang=js&"
export * from "./SettingPlanAddQ.vue?vue&type=script&lang=js&"
import style0 from "./SettingPlanAddQ.vue?vue&type=style&index=0&id=33a0fa5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a0fa5e",
  null
  
)

export default component.exports